@if (showButtonGroup() && hero(); as hero) {
  <div class="hero-button-group hero-button-group">
    @if (showPrimaryButton() || showSecondaryButton()) {
      <div
        class="hero-button-group__buttons"
        [class.hero-button-group__buttons--large]="large()"
      >
        @if (showPrimaryButton() && primaryButton(); as primaryButton) {
          <div>
            <crnt-button-alt
              class="hero-button-group__button"
              variant="primary"
              [inverted]="inverted()"
            >
              <a *wlGenericLink="primaryButton"></a>
            </crnt-button-alt>
          </div>
        }
        @if (showSecondaryButton() && secondaryButton(); as secondaryButton) {
          <div>
            <crnt-button-alt
              class="hero-button-group__button"
              variant="secondary"
              [inverted]="true"
            >
              <a *wlGenericLink="secondaryButton"></a>
            </crnt-button-alt>
          </div>
        }
      </div>
    }
    @if (appButtons(); as appButtons) {
      <div
        class="hero-button-group__apps"
        [class.hero-button-group__apps--large]="large()"
      >
        @for (appButton of appButtons; track appButton.type) {
          <a
            [href]="appButton.url"
            [attr.aria-label]="appButton.alt"
            class="hero-button-group__apps__app-icon"
          >
            <img [src]="appButton.src | deployUrl" alt="" height="40" />
          </a>
        }
      </div>
    }
  </div>
}
